import React from 'react';
import FormItemWrapper from './FormItemWrapper';
import { Button } from 'antd';

const SubmitButtonInput = ({ label = 'บันทึก' , style, formItemOptions, children, disabled, size }) => {
  return (
    <FormItemWrapper formItemOptions={formItemOptions}>
      <Button htmlType="submit" type="primary" style={style} disabled={disabled} size={size}>{children || label}</Button>
    </FormItemWrapper>
  );
};

export default SubmitButtonInput;
